var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-card"},[_c('div',{staticClass:"report-card__header"},[_c('h5',[(_vm.successIcon)?_c('fa',{staticClass:"icon",attrs:{"aria-hidden":"true","icon":"check-circle"}}):_vm._e(),_vm._v(_vm._s(_vm.header)+"\n    ")],1)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }